import { Button } from '@mui/material'
import FAIcon from 'Theme/FAIcon'

export const HeaderButton = ({ iconClassName, onClick }) => (
  <Button
    onClick={onClick}
    sx={(theme) => ({ margin: theme.spacing(0, 1), padding: 0, minWidth: 'unset' })}
  >
    <FAIcon
      iconClassName={iconClassName}
      boxSize={46}
      color="#9298AA"
      iconFontSize={18}
    />
  </Button>
)
